import React from "react";

import svg from "../../assets/images/icons/pdf_file.svg";

export const PDFFileIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "PDF"}
    />
);
